import { useEffect, useState } from "react";
import SideBar from "../../SideBar";
import "./SavedPage.css"
import { useNavigate } from "react-router-dom";
import { BACKEND_LINK } from "../../App";
import AccountWidget from "../../AccountWidget";
import SavedPalette from "./SavedPalette";
import { Helmet } from "react-helmet-async";

function SavedPage({username, logout}) {
    const navigate = useNavigate();
    const [savedIdeas, setSavedIdeas] = useState(null);
    const [orderBy, setOrderBy] = useState("recent");
    const [showPalette, setShowPalette] = useState(true);
    const [showPrompt, setShowPrompt] = useState(true);
    const [showPalettePrompt, setShowPalettePrompt] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    function getSavedPalettes() {
        fetch(BACKEND_LINK + "/color/saved", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
        })
        .then(response => {
        if (response.status === 403) {
            // temporary solution
            navigate("/generate/palette-idea");
            return;
        } else if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
        })
        .then(data => {
        if (data) {
            if(orderBy == "oldest") data.sort((a, b) => a.order - b.order);
            else data.sort((a, b) => b.order - a.order);
            setSavedIdeas(data);
        }
        })
        .catch(error => console.error(error));
    }

    useEffect(() => {
      getSavedPalettes();
    },[])

    function deleteSavedPalette(paletteId) {
        fetch(BACKEND_LINK + "/color/saved/" + paletteId, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include"
        })
        .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return;
        })
        .then(() => {
            getSavedPalettes();
        })
        .catch(error => console.error(error));
    }
    
    const handleOrderChange = (e) => {
        const value = e.target.value;
        setOrderBy(value);
        if (value == "recent") sortOrderAscending();
        else if (value == "oldest") sortOrderDescending();
    };

    function sortOrderAscending() {
        const sorted = savedIdeas.sort((a, b) => b.order - a.order);
        setSavedIdeas(sorted)
    }

    function sortOrderDescending() {
        const sorted = savedIdeas.sort((a, b) => a.order - b.order);
        setSavedIdeas(sorted)
    }

    return(
      <>
        <Helmet>
          <title>Saved Ideas and Palettes</title>
          <meta name="description" content="Here you can revisit your saved generated ideas and color palettes." />
          <link rel="canonical" href="https://palettemuse.org/saved" />
        </Helmet>
        <div className='main'>
          <SideBar loggedIn={username != null} isOpen={sidebarOpen} onToggle={setSidebarOpen}></SideBar>
          <button className="menu-toggle" onClick={() => setSidebarOpen(!sidebarOpen)} aria-label="Toggle menu">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <h1 className="title">
              Saved Palettes
          </h1>
          <div className="saved-palettes">
              {savedIdeas != null ? savedIdeas.map((idea, index) => (
                  (idea.colors != null && idea.colors.length != 0 && idea.prompt == null && showPalette || (idea.colors == null || idea.colors.length == 0) && idea.prompt != null &&
                      showPrompt || idea.colors != null && idea.colors.length != 0 && idea.prompt != null && showPalettePrompt
                  ) ?
                  <SavedPalette
                      key={idea.order ?? `${idea.prompt}-${index}`}
                      colors={idea.colors}
                      prompt={idea.prompt}
                      deleteFunc={() => deleteSavedPalette(idea.order ?? -1)}
                  ></SavedPalette>
                  : null
              )) : null}
          </div>
          <div className="options">
              <div className="options-card">
                  <h2 className="options-title">Sort By</h2>
                  <label className="option-label" htmlFor="sort-select">Sort by</label>
                  <select id="sort-select" className="option-select" value={orderBy} onChange={handleOrderChange}>
                      <option value="recent">Most recent</option>
                      <option value="oldest">Oldest</option>
                  </select>

                  <h2 className="options-title">View</h2>
                  <label className="option-item">
                      <input type="checkbox" checked={showPalette} onChange={(e) => {setShowPalette(e.target.checked);} } />
                      <span>Palette only</span>
                  </label>
                  <label className="option-item">
                      <input type="checkbox" checked={showPrompt} onChange={(e) => {setShowPrompt(e.target.checked);} } />
                      <span>Prompt only</span>
                  </label>
                  <label className="option-item">
                      <input type="checkbox" checked={showPalettePrompt} onChange={(e) => {setShowPalettePrompt(e.target.checked);} } />
                      <span>Palette + Prompt</span>
                  </label>
              </div>
          </div>
          <AccountWidget username={username} logout={logout}></AccountWidget>
        </div>
      </>
    );
}

export default SavedPage;